import { AHSeparator, Box } from "arkh";
import React, { Suspense, useCallback } from "react";
import { PLUCategoryItem } from "./PLUCategoryItem/PLUCategoryItem";
import { PLUCategoryAddItem } from "./PLUCategoryItem/PLUCategoryAddItem";
import { PLUCategoryItem_PLUCategory$key } from "./PLUCategoryItem/__generated__/PLUCategoryItem_PLUCategory.graphql";
import { PLUCategorySelectorShowHidden } from "./PLUCategorySelectorShowHiddenButton";

export const PLUCategorySelector = React.memo(InnerPLUCategorySelector);

function InnerPLUCategorySelector(props: {
  selectedCategory: string | undefined;
  setSelectedCategory: (selected: string | undefined) => void;
  pluCategories: (
    | "ADD_ITEM"
    | (PLUCategoryItem_PLUCategory$key & { id: string })
  )[];
}) {
  const renderItem = useCallback(
    (
      category: "ADD_ITEM" | (PLUCategoryItem_PLUCategory$key & { id: string }),
      index: number
    ) => {
      return category === "ADD_ITEM" ? (
        <PLUCategoryAddItem key="ADD_CATEGORY_ITEM" />
      ) : (
        <PLUCategoryItem
          key={category.id}
          pluCategory={category}
          index={index}
          selectedCategory={props.selectedCategory}
          setSelectedCategory={props.setSelectedCategory}
        />
      );
    },
    [props.selectedCategory, props.setSelectedCategory]
  );

  return (
    <>
      <Box
        color="surface"
        style={{ flexWrap: "wrap", flexDirection: "row" }}
        spaceHorizontal="xsmall"
        spaceTop="xsmall"
        spaceBottom="small"
      >
        {props.pluCategories.map(renderItem)}
        <Box style={{ flex: 1 }} />
        <Suspense fallback={null}>
          <PLUCategorySelectorShowHidden
            categoriesShowing={props.pluCategories}
          />
        </Suspense>
      </Box>
      <AHSeparator />
    </>
  );
}
